import { render } from "./SpiritualityInteractiveVideo.vue?vue&type=template&id=1c92ded8&scoped=true"
import script from "./SpiritualityInteractiveVideo.vue?vue&type=script&lang=js"
export * from "./SpiritualityInteractiveVideo.vue?vue&type=script&lang=js"

import "./SpiritualityInteractiveVideo.vue?vue&type=style&index=0&id=1c92ded8&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c92ded8"]])

export default __exports__